import React, { useState, useEffect } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import api from "../../services/api";

import Swal from "sweetalert2";

const VignetteList = (props) => {
    const [vignettes, setVignettes] = useState([]);
    const [vignettesToShow, setVignettesToShow] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(function () {
        loadList();
    }, []);

    async function loadList() {
        setLoaded(false);

        const responseGet = await api.get("/vignette");

        setVignettes(responseGet.data.data);
        setVignettesToShow(responseGet.data.data);
        setLoaded(true);
    }

    function handleSearchBar() {
        setLoaded(false);

        const originalItems = vignettes;

        if (searchText === "") {
            setVignettesToShow(originalItems);
            setLoaded(true);
            return;
        }

        let filteredItems = originalItems.filter(
            (item) =>
                item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
        );

        setVignettesToShow(filteredItems);
        setLoaded(true);
    }

    async function handleDelete(itemDelete) {
        Swal.fire({
            title: `Tem certeza que deseja excluir a vinheta ${itemDelete.name}?`,
            text: "Não será possível voltar atrás!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero excluir!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (!result.value) {
                Swal.fire(
                    "Cancelado!",
                    "Nenhum dado será excluído.",
                    "success"
                );
            } else {
                setLoaded(false);

                try {
                    const responseDelete = await api.delete(
                        `/vignette/${itemDelete._id}`
                    );

                    if (responseDelete.status === 204) {
                        const newItems = vignettes.filter(
                            (item) => item._id !== itemDelete._id
                        );
                        setVignettes(newItems);
                        setVignettesToShow(newItems);
                        setLoaded(true);
                    } else {
                        throw new Error("Erro ao deletar");
                    }
                } catch (error) {
                    console.log(error);
                    setLoaded(true);
                    Swal.fire({
                        type: "error",
                        title: "Oops...",
                        text: "Tivemos um problema ao excluir essa vinheta. Contate o suporte!",
                    });
                }
            }
        });
    }

    return (
        <Layout
            menuActive="registers"
            pageTitle="Lista de Vinhetas"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">Lista de Vinhetas</div>
                            <ul className="card-action">
                                <li>
                                    <Link
                                        to="/vinhetas/nova"
                                        className="btn btn-sm btn-success"
                                    >
                                        Nova <i className="fa fa-plus"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {vignettes.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{item.name}</td>
                                                        <td>
                                                            <div className="col-xs-12">
                                                                <div className="col-xs-12">
                                                                    <button
                                                                        className="btn btn-xs btn-danger"
                                                                        style={{
                                                                            width: "100%",
                                                                        }}
                                                                        onClick={() =>
                                                                            handleDelete(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        Excluir
                                                                        <div className="icon fa fa-trash-o"></div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(VignetteList);
